import {
  ClickAwayListener,
  Tooltip,
  TooltipProps,
  styled,
} from "@mui/material";
import { MouseEvent, PropsWithChildren, useCallback, useState } from "react";

export const BigTooltip = styled(
  ({ className, children, ...props }: PropsWithChildren<TooltipProps>) => {
    const [open, setOpen] = useState(false);

    const handleTooltipClose = useCallback(() => {
      if (open) setOpen(false);
    }, [open, setOpen]);

    const toggleTooltipOpen = useCallback(
      (event: MouseEvent) => {
        event.stopPropagation();
        setOpen((prev) => !prev);
      },
      [setOpen]
    );

    return (
      <ClickAwayListener
        onClickAway={handleTooltipClose}
        disableReactTree={true}
      >
        <Tooltip
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClick={toggleTooltipOpen}
          {...props}
          classes={{ popper: className }}
          slotProps={{
            popper: {
              onClick: (event) => {
                event.stopPropagation();
              },
            },
          }}
        >
          {children}
        </Tooltip>
      </ClickAwayListener>
    );
  }
)(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    padding: theme.spacing(1),
    boxShadow: theme.shadows[5],
    whiteSpace: "pre-wrap",
  },
}));
